import { onlineUrlError } from './online_url';

// @context TGW-2195 詳細ページの「公開まであと N 項目」の計算（詳細設計 §3.8）。
//   数える対象は「日時・開催場所（オンライン時は接続先URL）・チケット」の3つだけ。
//   タイトル字数や整合エラーは基本ページ側の案内で扱う。
//   チケットはサーバー側の必須検査（events_plans_params.empty?）に対応するもので、
//   validate() には無い。論理削除済みの行は数に入れない（削除済みだけ残っていても未充足）。
export const countRequiredRemaining = ({ event, eventsPlans }) => {
  const e = event || {};
  return (
    (!e.event_date || !e.event_end_datetime ? 1 : 0) +
    ((e.is_online ? !!onlineUrlError({ isOnline: true, url: e.online_url }) : !e.place) ? 1 : 0) +
    ((eventsPlans || []).filter((p) => !p.is_deleted).length === 0 ? 1 : 0)
  );
};

export default countRequiredRemaining;
